import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';
import {
  IClientInvestmentWorkflow,
  IClientInvestmentWorkflowsFilter,
} from '@aksia/models';

export interface IClientInvestmentWorkflowsPagedResponse {
  workflows: IClientInvestmentWorkflow[];
  totalCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class ClientInvestmentWorkflowsService {
  private api = inject(CedricApiService);
  private controller = 'ClientInvestmentWorkflows';

  getFiltered(
    filter: IClientInvestmentWorkflowsFilter,
  ): Observable<IClientInvestmentWorkflowsPagedResponse> {
    return this.api
      .get(`${this.controller}/GetFiltered?${this.toQueryString(filter)}`)
      .pipe(
        map((res: any) => ({
          workflows: res.workflows ?? [],
          totalCount: res.totalCount ?? 0,
        })),
      );
  }

  exportExcel(filter: IClientInvestmentWorkflowsFilter): Observable<Blob> {
    return this.api.getBlob(
      `${this.controller}/ExportExcel?${this.toQueryString(filter)}`,
    );
  }

  private toQueryString(filter: IClientInvestmentWorkflowsFilter): string {
    return Object.entries(filter)
      .filter(([, v]) => v !== null && v !== undefined && v !== '')
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
  }
}
